// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ErrorComponent__wrapper","errorWrapper":"ErrorComponent__errorWrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ErrorComponent/ErrorComponent.scss
// module id = ./src/components/ErrorComponent/ErrorComponent.scss
// module chunks = 2